import PrecallSurvey from '@components/pages/account/survey/PrecallSurvey';
import { AEP_SurveyStep } from '@components/pages/account/survey/PrecallSurvey/constants';

export const PrecallAepPrescriptions = () => <PrecallSurvey step={AEP_SurveyStep.PRESCRIPTION} />;

export default PrecallAepPrescriptions;
